import { render, staticRenderFns } from "./Sunburst.vue?vue&type=template&id=0b0a2bc0"
import script from "./Sunburst.vue?vue&type=script&lang=js"
export * from "./Sunburst.vue?vue&type=script&lang=js"
import style0 from "./Sunburst.vue?vue&type=style&index=0&id=0b0a2bc0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports